module.exports = __webpack_public_path__ + "img/Postmodernisme_Lars-Saabye-Christensen.e27388f2.jpg";